import * as React from "react";
import { Box, FormControl, MenuItem, Select, InputLabel } from "@mui/material";
import BaseSelect from "../BaseSelect";

export default function BaseHourMinutePicker({
  hour,
  minute,
  onChange,
  disabled,
}) {
  // Generate hour (0–12) and minute (0–59) options
  const hours = Array.from({ length: 13 }, (_, i) => i); // 0–12
  const minutes = Array.from({ length: 60 }, (_, i) => i); // 0–59

  return (
    <Box display="flex" gap={1}>
      {/* Hour Picker */}
      <FormControl>
        <BaseSelect
          labelId="hour-label"
          value={hour}
          className={"h-10"}
          // placeholder="Hour"
          label={<p>Hours</p>}
          labelShrink={true}
          isDefaultField={false}
          onChange={(e) => onChange({ hour: Number(e.target.value), minute })}
          disabled={disabled}
          options={hours.map((h) => {
            return {
              label: h.toString(),
              value: h,
            };
          })}
        ></BaseSelect>
      </FormControl>

      {/* Minute Picker */}
      <FormControl>
        <BaseSelect
          labelId="minute-label"
          value={minute}
          label={<p>Minutes</p>}
          labelShrink={true}
          isDefaultField={false}
          onChange={(e) => onChange({ hour, minute: Number(e.target.value) })}
          disabled={disabled}
          options={minutes.map((m) => {
            return { label: m.toString(), value: m };
          })}
        ></BaseSelect>
      </FormControl>
    </Box>
  );
}
